<template>
  <div>
    <el-dialog
      title="Reasignar Fecha de Cierre"
      :visible.sync="isItVisible"
      @open="OnOpeningDialog"
      @close="handleClose"
      width="30%"
    >
      <el-form :model="form">
        <el-form-item
          label="Fecha de cierre actual:"
          :label-width="formLabelWidth"
        >
          <el-date-picker
            v-model="form.ActualDate"
            type="date"
            placeholder="Seleccione una fecha"
            disabled
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item
          label="Fecha de cierre nueva:"
          :label-width="formLabelWidth"
        >
          <el-date-picker
            v-model="form.NewDate"
            type="date"
            placeholder="Seleccione una fecha"
          >
          </el-date-picker>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleClose">Cancelar</el-button>
        <el-button type="primary" @click="SendNewDate">Confirmar</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "ChangeCloseDate",
  props: {
    CloseDateDialogVisible: {
      type: Boolean,
      default: false,
      required: true
    },
    ActualTaskInfo: {
      type: Object,
      default: () => ({}),
      required: false
    }
  },
  data() {
    return {
      form: {
        ActualDate: "",
        NewDate: "",
        formLabelWidth: "300px"
      }
    };
  },
  computed: {
    isItVisible() {
      return this.CloseDateDialogVisible;
    }
  },
  methods: {
    handleClose() {
      this.form.NewDate = "";
      this.$emit("ClosingCloseDateDialog", false);
    },
    OnOpeningDialog() {
      this.form.ActualDate = this.ActualTaskInfo?.CloseDate || "";
    },
    async SendNewDate() {
      if (this.form.NewDate) {
        const taskId = Number(this.ActualTaskInfo.OriginalID);
        if (Number.isNaN(taskId)) {
          this.$message.error("No se encontro un taskId valido.");
          return;
        }
        const newDateParam =
          this.form.NewDate instanceof Date
            ? this.form.NewDate.toISOString()
            : String(this.form.NewDate);
        const requestUrl = `/api/ReporteGestion/ChangeCloseDateTask?taskId=${taskId}&newDate=${encodeURIComponent(
          newDateParam
        )}`;

        await this.$http.put(requestUrl, null).then(async () => {
          this.$message.success("Fecha actualizada correctamente");
          this.$emit("NewCloseDateUpdated");
          this.$emit("ClosingCloseDateDialog", false);
        });
      } else {
        this.$message.error("Por favor, seleccione una nueva fecha.");
      }
    }
  }
};
</script>

<style lang="scss" scoped></style>
